"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoModalBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useLocale_1 = require("../../../hooks/useLocale/useLocale");
const messages_1 = require("../../../core/i18n/messages");
const Styled = __importStar(require("../Modal.styles"));
const InfoModalBody = (props) => {
    const { formatMessage } = (0, useLocale_1.useLocale)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.ModalBody, { "$size": props.size || 'medium', "$withBottomPadding": !props.onSubmit, children: props.children }), props.onSubmit && ((0, jsx_runtime_1.jsx)(Styled.ButtonsWrapper, { children: (0, jsx_runtime_1.jsx)(Styled.ConfirmButton, { onClick: props.onSubmit, variant: "contained", color: "primary", size: "small", disabled: props.submitButtonDisabled, isLoading: props.isLoading, children: props.submitButtonText ? props.submitButtonText : formatMessage({ id: messages_1.AppMessages['common.confirm'] }) }) }))] }));
};
exports.InfoModalBody = InfoModalBody;
